/**
 * @generated SignedSource<<8fdaea18f5bd03d51b423e665ed010f8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type productFragment$data = {
  readonly id: string;
  readonly externalRef: string;
  readonly accountId: string | null;
  readonly name: string;
  readonly description: string | null;
  readonly type: string | null;
  readonly price: number;
  readonly currencyCode: string;
  readonly meta: any | null;
  readonly createdAt: any | null;
  readonly " $fragmentType": "productFragment";
};
export type productFragment$key = {
  readonly " $data"?: productFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"productFragment">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "productFragment"
};

(node as any).hash = "cfaa255d7be9a6e4b094a6e7cbf2c99b";

export default node;
